import type { ReactNode } from 'react';
import type { CounselPanelTheme } from '../../store/lexCounselStore';

/** Panel width + right gutter (matches md:p-3 pr-3 push layout). */
export const LEX_COUNSEL_PANEL_WIDTH = 400;
export const LEX_COUNSEL_PANEL_GUTTER = 12;
export const LEX_COUNSEL_PANEL_OUTER_WIDTH =
  LEX_COUNSEL_PANEL_WIDTH + LEX_COUNSEL_PANEL_GUTTER;

export const COUNSEL_PANEL_CLASS = 'lexcounsel-panel';

/** Shared Lex Counsel panel typography — driven by scoped CSS variables. */
export const PANEL_DISPLAY =
  'text-[28px] font-normal leading-[1.2] tracking-tight text-[var(--counsel-text)]';
export const PANEL_GREETING =
  'text-[22px] font-normal leading-tight tracking-tight text-[var(--counsel-text)]';
export const PANEL_BODY = 'text-[14px] leading-snug text-[var(--counsel-text)]';
export const PANEL_MUTED = 'text-[14px] leading-snug text-[var(--counsel-text-muted)]';
export const PANEL_CAPTION = 'text-[12px] leading-snug text-[var(--counsel-text-muted)]';

/** Reusable surface / control classes */
export const COUNSEL_SURFACE = 'bg-[var(--counsel-bg)] text-[var(--counsel-text)]';
export const COUNSEL_ICON_BTN =
  'text-[var(--counsel-icon)] hover:bg-[var(--counsel-hover)]';
export const COUNSEL_BUBBLE = 'bg-[var(--counsel-bubble)]';
export const COUNSEL_COMPOSER =
  'rounded-[28px] border border-[var(--counsel-border)] bg-[var(--counsel-composer-bg)]';
export const COUNSEL_COMPOSER_CARD =
  'overflow-hidden rounded-[28px] border border-[var(--counsel-border)] bg-[var(--counsel-composer-bg)]';
export const COUNSEL_COMPOSER_BODY = 'px-4 pt-3 pb-2';
export const COUNSEL_SEND_BTN =
  'bg-[var(--counsel-send-bg)] text-[var(--counsel-send-text)]';
export const COUNSEL_CHIP =
  'border border-[var(--counsel-border)] bg-[var(--counsel-chip-bg)] hover:bg-[var(--counsel-chip-hover)]';

export function counselProseClass(theme: CounselPanelTheme): string {
  return theme === 'light'
    ? 'prose prose-sm max-w-none'
    : 'prose prose-sm max-w-none prose-invert';
}

const GRADIENT_NAME_STYLE = {
  backgroundImage: 'linear-gradient(90deg, #4285f4 0%, #9b72cb 45%, #d96570 100%)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
} as const;

export function LexCounselGradientName({ children }: { children: ReactNode }) {
  return <span style={GRADIENT_NAME_STYLE}>{children}</span>;
}
